import { getBreakDownById } from './breakdownsRequestConfigs';

class BreakdownApi {
    getBreakDownById = getBreakDownById;
}

class BreakdownFactory {
    breakdown = BreakdownApi;
    create() {
        return new this.breakdown();
    }
}

export const breakdown = new BreakdownFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/BreakdownsApi/index.js